import { rutValidator } from './rut-helpers/rutValidator';
import { MAX_PERSON_VALUE, MIN_PERSON_VALUE } from './rut-helpers/constants';

export const errorCode = 'INVALID_RUT';
export const validateRut = rutValidator({
  errorCode,
  min: MIN_PERSON_VALUE,
  max: MAX_PERSON_VALUE
});
